import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import sdk from "@/sdk";

export const useBondDetail = (_id: string) => {
  const [holdersPage, setHoldersPage] = useState(0);
  const [payoutsPage, setPayoutsPage] = useState(0);
  const [withdrawalsPage, setWithdrawalsPage] = useState(0);

  const limit = 20;

  const { data: bondData, isLoading: isBondLoading } = useQuery(
    ["bond", _id],
    () => sdk.getBond({ _id }),
    { select: (data) => data.getBond },
  );

  const { data: holdersData, isLoading: isHoldersLoading } = useQuery(
    ["bondHolders", _id, holdersPage],
    () => sdk.bondHolders({ bondId: _id, page: holdersPage, limit }),
    { select: (data) => data.bondHolders },
  );

  const { data: payoutsData, isLoading: isPayoutsLoading } = useQuery(
    ["bondPayoutHistory", _id, payoutsPage],
    () => sdk.bondPayoutHistory({ bondId: _id, page: payoutsPage, limit }),
    { select: (data) => data.bondPayoutHistory },
  );

  const { data: withdrawalsData, isLoading: isWithdrawalsLoading } = useQuery(
    ["bondWithdrawalHistory", _id, withdrawalsPage],
    () =>
      sdk.bondWithdrawalHistory({
        bondId: _id,
        page: withdrawalsPage,
        limit,
      }),
    { select: (data) => data.bondWithdrawalHistory },
  );

  const { data: batchesData, isLoading: isBatchesLoading } = useQuery(
    ["bondPayoutBatches", _id],
    () => sdk.bondPayoutBatches({ bondId: _id }),
    {
      select: (data) => data.bondPayoutBatches,
      refetchInterval: (data) =>
        data?.some((b) => b.status === "processing") ? 5000 : false,
    },
  );

  return {
    bondData,
    isBondLoading,
    holdersData,
    isHoldersLoading,
    holdersPage,
    setHoldersPage,
    payoutsData,
    isPayoutsLoading,
    payoutsPage,
    setPayoutsPage,
    withdrawalsData,
    isWithdrawalsLoading,
    withdrawalsPage,
    setWithdrawalsPage,
    batchesData,
    isBatchesLoading,
    limit,
  };
};
